import { render, staticRenderFns } from "./DashboardProductRegistries.vue?vue&type=template&id=4dcabe44&scoped=true&"
import script from "./DashboardProductRegistries.vue?vue&type=script&lang=js&"
export * from "./DashboardProductRegistries.vue?vue&type=script&lang=js&"
import style0 from "./DashboardProductRegistries.vue?vue&type=style&index=0&id=4dcabe44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dcabe44",
  null
  
)

export default component.exports